import * as utils from './utils.js';
import i18n from './i18n/i18n.js';
import { generateReportPDF, formatOperationTypeTitle } from './pdfUtils.js';
import { formatReportTimelineDate } from './components/reports/reportHelpers.js';

function buildItemColumns(item, role) {
  const isBroker = role === 'broker';
  const columns = [];

  if (isBroker && item.partner) {
    columns.push({
      header: i18n.t('reports.partnerName'),
      data: item.partner?.name || item.partner?.id || '-',
      cellStyle: { cellWidth: 14 }
    });
  }

  columns.push(
    { header: 'ID', data: item.id || '-', cellStyle: { /*stretch*/ } },
    { header: i18n.t('quoteInfo.alias'), data: item.alias || '-', cellStyle: { cellWidth: 14 } },
    { header: i18n.t('quoteInfo.clientName'), data: item.company_name || item.company?.name || item.company?.id || '-', cellStyle: { cellWidth: 14 } },
    { header: i18n.t('broker.labels.transactionPurpose'), data: formatOperationTypeTitle(item.operationType), cellStyle: { cellWidth: 20 } },
    { header: i18n.t('management.brokers.headers.timeCreated'), data: formatReportTimelineDate(item.timecreate), cellStyle: { cellWidth: 20 } },
    { header: 'RFQ ID', data: item.rfqId || '-', cellStyle: { cellWidth: 12 } },
    { header: i18n.t('quoteInfo.rfqDate'), data: formatReportTimelineDate(item.rfq_timecreate), cellStyle: { cellWidth: 16 } },
    { header: i18n.t('quoteInfo.ccy'), data: item.ccy || '-', cellStyle: { cellWidth: 12 } },
    { header: i18n.t('quoteInfo.amountCcy'), data: utils.formatPrice(item.qty) || '-', cellStyle: { cellWidth: 18 } },
    { header: i18n.t('quoteInfo.clientRate'), data: item.rfq_final_rate != null ? Number(item.rfq_final_rate).toFixed(4) : '-', cellStyle: { cellWidth: 12 } },
    { header: i18n.t('quoteInfo.volumeCcyBrl'), data: item.volume_brl != null && Number.isFinite(Number(item.volume_brl)) ? 'R$ ' + utils.formatBRLPretty(Number(item.volume_brl)) : '-', cellStyle: { cellWidth: 16 } },
    { header: i18n.t('quoteInfo.side'), data: item.side || '-', cellStyle: { cellWidth: 12 } },
    { header: i18n.t('quoteInfo.status'), data: item.status || '-', cellStyle: { cellWidth: 12 } }
  );

  return columns;
}

export async function generateOperationsPDF(reportsData) {
  await generateReportPDF({ reportsData, buildItemColumns, fileName: 'report_operation_fx' });
}
